import {setCancelStatus} from "@/store/admin/transactions/actions";

const resource = '/admin/v1/transactions'

export default $axios => ({
  getList(payload) {
    return $axios.get(`${resource}`, {params: payload})
  },
  getAmountInRange(payload) {
    return $axios.get(`${resource}/get-amount-in-range`, {params: payload})
  },
  getAmountMonth() {
    return $axios.get(`${resource}/month`)
  },
  setCancelStatus(payload) {
    return $axios.post(`${resource}/set-cancel-status/${payload.id}`, { is_cancel: payload.isCancel })
  },
})
